// Plot data for multipanel demo
// Extracted and simplified from actual data in /pages/multipanel/scatterpplot.js and ridgeline.js

// Fixed seed for reproducible data (used for violin plot)
const seededRandom = (seed: number) => {
  let value = seed;
  return () => {
    value = (value * 9301 + 49297) % 233280;
    return value / 233280;
  };
};

// Real scatter plot data points (sampled every 5th point from actual data)
const CONTROL_SCATTER_X = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const CONTROL_SCATTER_Y = [56.876, 63.655, 60.459, 69.665, 61.524, 61.670, 60.348, 67.780, 57.732, 60.110, 59.761, 63.069, 60.434, 64.543, 63.150, 71.277, 68.365, 69.460, 69.857, 68.396, 67.551, 66.529, 69.138, 63.363, 67.786, 71.346, 50.188, 42.113, 42.542, 47.314, 40.499, 47.002, 48.581, 47.171, 46.759, 45.541, 42.213, 40.881, 42.469, 58.226, 64.805, 57.648, 61.615, 60.626, 58.351, 57.339, 56.743, 59.250, 57.553, 60.371, 58.573, 67.003, 60.106, 61.511, 64.564, 59.157, 59.121, 58.227, 62.522, 58.308, 57.438, 61.437, 53.221, 57.291, 57.901, 61.050, 63.466, 58.519, 57.770, 59.509, 59.480, 51.047, 56.731, 54.451, 61.561, 54.390, 53.794, 49.403, 69.494, 63.046, 62.016, 65.079, 66.349, 62.999, 64.146, 60.262, 63.127, 59.761, 53.429, 53.201, 56.088, 62.905, 66.233, 65.299, 61.288, 58.044, 58.521, 62.419, 57.817, 57.911, 62.389, 56.357, 59.546, 60.557, 73.968, 67.879, 67.839, 66.241, 70.183, 66.731, 69.227, 71.640, 68.770, 68.906, 72.420, 68.814, 59.991];

const TREATMENT_SCATTER_X = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const TREATMENT_SCATTER_Y = [63.673, 62.208, 67.270, 56.861, 62.454, 56.519, 57.860, 57.018, 47.067, 62.423, 62.858, 53.423, 56.734, 60.174, 56.418, 59.208, 56.790, 57.394, 59.137, 57.200, 55.162, 51.561, 59.696, 56.263, 50.764, 52.396, 49.818, 57.332, 53.905, 48.570, 46.888, 60.433, 59.792, 56.403, 60.777, 77.703, 74.533, 68.333, 65.353, 59.340, 60.199, 50.005, 51.767, 43.669, 57.226, 58.882, 46.370, 53.801, 56.321, 49.988, 53.722, 51.835, 56.753, 63.916, 58.136, 54.751, 52.621, 56.546, 59.728, 51.721, 49.441, 60.760, 55.465, 48.449, 48.729, 78.422, 73.892, 70.830, 69.433, 71.037, 56.549, 53.773, 50.928, 48.699, 68.127, 61.862, 58.391, 58.595, 52.012, 47.892, 49.173, 45.272, 44.049, 58.477, 57.721, 57.610, 57.729, 52.862, 54.941, 50.178, 49.947, 69.151, 67.030, 61.317, 58.561, 52.275, 74.113, 66.559, 64.500, 64.387];

// LOWESS trend lines (sampled every 3rd point from actual data)
const CONTROL_TREND_X = [0, 0.1809, 0.3618, 0.5427, 0.7236, 0.9045, 1.0854, 1.2663, 1.4472, 1.6281, 1.8090, 1.9899, 2.1709, 2.3518, 2.5327, 2.7136, 2.8945, 3.0754, 3.2563, 3.4372, 3.6181, 3.7990, 3.9799, 4.1608, 4.3417, 4.5226, 4.7035, 4.8844, 5.0653, 5.2462, 5.4271, 5.6080, 5.7889, 5.9698, 6.1508, 6.3317, 6.5126, 6.6935, 6.8744, 7.0553, 7.2362, 7.4171, 7.5980, 7.7789, 7.9598, 8.1407, 8.3216, 8.5025, 8.6834, 8.8643, 9.0452, 9.2261, 9.4070, 9.5879, 9.7688, 9.9497, 10.1307, 10.3116, 10.4925, 10.6734, 10.8543, 11.0352, 11.2161, 11.3970, 11.5779, 11.7588, 11.9397, 12];
const CONTROL_TREND_Y = [59.94915640485608, 59.90017974897893, 59.92034491958932, 59.902137394270625, 59.961056192263484, 59.963299544875284, 59.91715153886982, 59.904780936341, 59.86955149878281, 59.86343285477423, 59.82453693904541, 59.78079982311208, 59.71409677796896, 59.6516355566563, 59.616051665597496, 59.58738918414163, 59.53751867373522, 59.46669244149054, 59.37164789100524, 59.31458085986296, 59.23178812297412, 59.111584829622956, 59.00859873953503, 58.90192321641961, 58.854921464297746, 58.81949022232104, 58.734689096809184, 58.656190641963484, 58.59623797177079, 58.58344469394544, 58.515467381448076, 58.511826158281345, 58.49448653962288, 58.47756909064154, 58.47437881507204, 58.398727284775774, 58.41967454106958, 58.47090171430851, 58.47086955818723, 58.39117214471512, 58.37024044883548, 58.3523155854007, 58.342709017262635, 58.3571749390032, 58.35594444161587, 58.244990727631134, 58.113507206957024, 57.9892951916692, 57.879469405980615, 57.80239832037662, 57.7237923468041, 57.66408625293023, 57.58475521895552, 57.53334893049175, 57.41664977036234, 57.31151349041938, 57.32467954844421, 57.31722004829449, 57.304177862309416, 57.22690169090036, 57.24026538478978, 57.2648392213048, 57.26983755256208, 57.26132710498304, 57.26564205236585, 57.27542621143719, 57.29777122120518, 57.29777122120518];

const TREATMENT_TREND_X = [0, 0.1809, 0.3618, 0.5427, 0.7236, 0.9045, 1.0854, 1.2663, 1.4472, 1.6281, 1.8090, 1.9899, 2.1709, 2.3518, 2.5327, 2.7136, 2.8945, 3.0754, 3.2563, 3.4372, 3.6181, 3.7990, 3.9799, 4.1608, 4.3417, 4.5226, 4.7035, 4.8844, 5.0653, 5.2462, 5.4271, 5.6080, 5.7889, 5.9698, 6.1508, 6.3317, 6.5126, 6.6935, 6.8744, 7.0553, 7.2362, 7.4171, 7.5980, 7.7789, 7.9598, 8.1407, 8.3216, 8.5025, 8.6834, 8.8643, 9.0452, 9.2261, 9.4070, 9.5879, 9.7688, 9.9497, 10.1307, 10.3116, 10.4925, 10.6734, 10.8543, 11.0352, 11.2161, 11.3970, 11.5779, 11.7588, 11.9397, 12];
const TREATMENT_TREND_Y = [60.53835970448402, 60.422129271775646, 60.293665668142495, 60.16427151839469, 60.04670625401805, 59.87159768399052, 59.74468500068846, 59.601868581413925, 59.44424194439283, 59.29604641230947, 59.16431575083992, 58.9565618441614, 58.79315208230324, 58.58255781382037, 58.41025979118046, 58.2101403782436, 58.05574921854239, 57.91822378318237, 57.801381571621, 57.67045710590857, 57.53684795653348, 57.41794867228659, 57.30021229642276, 57.22856742605143, 57.18732667526386, 57.12159798723069, 57.003015695556414, 56.84194660764189, 56.66571446999596, 56.532340111019096, 56.3213045348233, 56.19232236867351, 56.03629113709974, 55.85104187360419, 55.69321116470754, 55.540848293170775, 55.39135950543878, 55.277847938974006, 55.144947036737015, 55.04237814957917, 54.965981994424155, 54.865437218193506, 54.776560779738844, 54.685174558033324, 54.59018571975992, 54.501152793456335, 54.43223883269951, 54.382172162024396, 54.348023771457164, 54.29328256947521, 54.142108138001035, 53.962577161771804, 53.75517352920326, 53.61358399303326, 53.45747894804117, 53.30630397365127, 53.15493354592904, 53.054624957855765, 52.938210909287626, 52.81075813502294, 52.67879746307815, 52.618591124878705, 52.58928331566486, 52.562586114223585, 52.52799970324134, 52.4952083775392, 52.4293079523041, 52.4293079523041];

// Confidence interval bands (aligned with trend lines - using same x-values)
// Use the same x-values as the trend lines for perfect alignment
const CONTROL_CI_UPPER_X = CONTROL_TREND_X;
const CONTROL_CI_UPPER_Y = [62.175, 62.015, 61.786, 61.599, 61.448, 61.422, 61.383, 61.284, 61.227, 61.197, 61.167, 61.179, 61.067, 60.972, 60.894, 60.900, 60.890, 60.870, 60.749, 60.620, 60.585, 60.531, 60.518, 60.288, 60.192, 60.168, 60.124, 60.079, 60.028, 59.921, 59.867, 59.841, 59.907, 60.009, 59.953, 59.910, 59.898, 59.963, 60.018, 60.011, 59.918, 59.893, 59.837, 59.872, 59.903, 59.775, 59.626, 59.457, 59.319, 59.251, 59.187, 59.068, 58.964, 58.879, 58.795, 58.722, 58.686, 58.650, 58.710, 58.689, 58.749, 58.849, 58.950, 59.105, 59.494, 59.681, 59.777, 59.777];
const CONTROL_CI_LOWER_X = CONTROL_TREND_X;
const CONTROL_CI_LOWER_Y = [57.724, 57.807, 58.021, 58.216, 58.415, 58.500, 58.524, 58.545, 58.514, 58.528, 58.512, 58.420, 58.414, 58.394, 58.369, 58.315, 58.221, 58.121, 58.059, 58.032, 57.957, 57.768, 57.564, 57.567, 57.545, 57.492, 57.420, 57.282, 57.193, 57.263, 57.190, 57.183, 57.092, 57.005, 56.999, 56.934, 56.937, 56.946, 56.834, 56.817, 56.807, 56.809, 56.842, 56.831, 56.826, 56.771, 56.646, 56.465, 56.335, 56.321, 56.244, 56.198, 56.137, 55.965, 55.970, 55.978, 55.831, 55.703, 55.622, 55.568, 55.380, 55.209, 55.055, 54.889, 54.819, 54.819, 54.819, 54.819];
const TREATMENT_CI_UPPER_X = TREATMENT_TREND_X;
const TREATMENT_CI_UPPER_Y = [62.564, 62.323, 62.014, 61.741, 61.489, 61.252, 61.096, 60.857, 60.700, 60.576, 60.460, 60.248, 60.090, 59.908, 59.734, 59.556, 59.435, 59.303, 59.182, 59.036, 58.913, 58.833, 58.739, 58.613, 58.531, 58.453, 58.403, 58.262, 58.076, 57.868, 57.655, 57.525, 57.368, 57.234, 57.030, 56.869, 56.683, 56.585, 56.507, 56.458, 56.328, 56.278, 56.182, 56.163, 56.129, 56.043, 55.948, 55.819, 55.780, 55.763, 55.702, 55.444, 55.215, 55.042, 54.914, 54.795, 54.619, 54.473, 54.328, 54.212, 54.111, 54.082, 54.119, 54.226, 54.273, 54.427, 54.550, 54.592];
const TREATMENT_CI_LOWER_X = TREATMENT_TREND_X;
const TREATMENT_CI_LOWER_Y = [58.512, 58.604, 58.677, 58.670, 58.650, 58.601, 58.524, 58.449, 58.254, 58.116, 58.026, 57.785, 57.618, 57.393, 57.209, 56.991, 56.786, 56.611, 56.511, 56.426, 56.249, 56.114, 55.928, 55.890, 55.892, 55.823, 55.713, 55.522, 55.365, 55.274, 55.124, 54.971, 54.799, 54.592, 54.475, 54.330, 54.210, 54.039, 53.864, 53.693, 53.635, 53.533, 53.430, 53.307, 53.103, 53.021, 52.995, 52.970, 52.931, 52.838, 52.727, 52.598, 52.457, 52.282, 52.099, 51.913, 51.785, 51.697, 51.623, 51.463, 51.347, 51.191, 51.081, 50.921, 50.762, 50.604, 50.375, 50.267];

// Helper to generate hover text
const generateHoverText = (x: number[], y: number[], treatment: string): string[] => {
  const minLength = Math.min(x.length, y.length);
  return x.slice(0, minLength).map((week, i) => {
    const biomarker = y[i];
    return `treatment: ${treatment}<br>week: ${week}<br>biomarker: ${biomarker !== undefined ? biomarker.toFixed(3) : 'N/A'}`;
  });
};

// Ensure arrays match in length
const minControlLength = Math.min(CONTROL_SCATTER_X.length, CONTROL_SCATTER_Y.length);
const minTreatmentLength = Math.min(TREATMENT_SCATTER_X.length, TREATMENT_SCATTER_Y.length);

const controlPoints = {
  x: CONTROL_SCATTER_X.slice(0, minControlLength),
  y: CONTROL_SCATTER_Y.slice(0, minControlLength),
  hovertext: generateHoverText(CONTROL_SCATTER_X, CONTROL_SCATTER_Y, "Control"),
};

const treatmentPoints = {
  x: TREATMENT_SCATTER_X.slice(0, minTreatmentLength),
  y: TREATMENT_SCATTER_Y.slice(0, minTreatmentLength),
  hovertext: generateHoverText(TREATMENT_SCATTER_X, TREATMENT_SCATTER_Y, "Treatment"),
};

export const scatterPlotData = {
  data: [
    // Control CI upper (for confidence band)
    {
      hoverinfo: "skip" as const,
      line: { width: 0, color: "#5CA3D0" },
      mode: "lines" as const,
      showlegend: false,
      x: CONTROL_CI_UPPER_X,
      y: CONTROL_CI_UPPER_Y,
      type: "scatter" as const,
    },
    // Control CI lower (fills to CI upper)
    {
      fill: "tonexty" as const,
      fillcolor: "rgba(92,163,208,0.2)",
      hoverinfo: "skip" as const,
      line: { width: 0, color: "#5CA3D0" },
      mode: "lines" as const,
      showlegend: false,
      x: CONTROL_CI_LOWER_X,
      y: CONTROL_CI_LOWER_Y,
      type: "scatter" as const,
    },
    // Control LOWESS trend line (from actual data)
    {
      hoverinfo: "skip" as const,
      line: { color: "#5CA3D0", width: 2 },
      mode: "lines" as const,
      showlegend: false,
      x: CONTROL_TREND_X,
      y: CONTROL_TREND_Y,
      type: "scatter" as const,
    },
    // Treatment CI upper (for confidence band)
    {
      hoverinfo: "skip" as const,
      line: { width: 0, color: "#14549F" },
      mode: "lines" as const,
      showlegend: false,
      x: TREATMENT_CI_UPPER_X,
      y: TREATMENT_CI_UPPER_Y,
      type: "scatter" as const,
    },
    // Treatment CI lower (fills to CI upper)
    {
      fill: "tonexty" as const,
      fillcolor: "rgba(20,84,159,0.2)",
      hoverinfo: "skip" as const,
      line: { width: 0, color: "#14549F" },
      mode: "lines" as const,
      showlegend: false,
      x: TREATMENT_CI_LOWER_X,
      y: TREATMENT_CI_LOWER_Y,
      type: "scatter" as const,
    },
    // Treatment LOWESS trend line (from actual data)
    {
      hoverinfo: "skip" as const,
      line: { color: "#14549F", width: 2 },
      mode: "lines" as const,
      showlegend: false,
      x: TREATMENT_TREND_X,
      y: TREATMENT_TREND_Y,
      type: "scatter" as const,
    },
    // Control scatter points (from actual data)
    {
      hoverinfo: "text" as const,
      hovertext: controlPoints.hovertext,
      x: controlPoints.x,
      y: controlPoints.y,
      type: "scatter" as const,
      mode: "markers" as const,
      name: "Control",
      marker: { color: "#5CA3D0", size: 3, opacity: 0.6 },
      showlegend: false,
    },
    // Treatment scatter points (from actual data)
    {
      hoverinfo: "text" as const,
      hovertext: treatmentPoints.hovertext,
      x: treatmentPoints.x,
      y: treatmentPoints.y,
      type: "scatter" as const,
      mode: "markers" as const,
      name: "Treatment",
      marker: { color: "#14549F", size: 3, opacity: 0.6 },
      showlegend: false,
    },
  ],
  layout: {
    margin: { l: 50, r: 20, t: 10, b: 40 },
    xaxis: { title: "Week", showgrid: true, gridcolor: "rgba(0,0,0,0.1)", range: [-0.5, 12.5] },
    yaxis: { title: "Biomarker", showgrid: true, gridcolor: "rgba(0,0,0,0.1)", range: [35, 80] },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    showlegend: false,
  },
};

// Forest plot with error bars for confidence intervals
const sites = ["S02", "S04", "S01", "S03", "S06", "S08"];
const logOdds = [1.9459101490553135, 1.3862943611198906, 0.7114963192281418, 0, -1.0986122886681096, -1.3862943611198906];
const ciLower = [-0.923236065413374, -2.008525221715109, -0.969257720307132, -3.3948195828349994, -4.936076729328548, -4.78111394395489];
const ciUpper = [4.8150563635240005, 4.78111394395489, 2.3922503587634156, 3.3948195828349994, 2.738852151992329, 2.008525221715109];

export const forestPlotData = {
  data: [
    // Zero line
    {
      hoverinfo: "skip" as const,
      line: { color: "rgba(156,163,175,0.4)", dash: "dash" as const, width: 1.5 },
      mode: "lines" as const,
      showlegend: false,
      x: [0, 0],
      y: [sites[0], sites[sites.length - 1]],
      type: "scatter" as const,
    },
    // Confidence interval lines
    ...sites.map((site, i) => ({
      hoverinfo: "skip" as const,
      line: { color: "rgba(0,0,0,0.4)", width: 1.5 },
      mode: "lines" as const,
      showlegend: false,
      x: [ciLower[i], ciUpper[i]],
      y: [site, site],
      type: "scatter" as const,
    })),
    // Data points with error bars
    {
      hoverinfo: "text" as const,
      hovertext: [
        "logOR: 1.95 (95% CI: -0.92, 4.82)",
        "logOR: 1.39 (95% CI: -2.01, 4.78)",
        "logOR: 0.71 (95% CI: -0.97, 2.39)",
        "logOR: 0.00 (95% CI: -3.39, 3.39)",
        "logOR: -1.10 (95% CI: -4.94, 2.74)",
        "logOR: -1.39 (95% CI: -4.78, 2.01)",
      ],
      marker: { color: "rgba(0,0,0,0.5)", size: 7 },
      mode: "markers" as const,
      name: "Site logOR",
      x: logOdds,
      y: sites,
      type: "scatter" as const,
      error_x: {
        type: "data" as const,
        symmetric: false,
        array: logOdds.map((lo, i) => ciUpper[i] - lo),
        arrayminus: logOdds.map((lo, i) => lo - ciLower[i]),
        width: 0,
        thickness: 1.5,
        color: "rgba(0,0,0,0.4)",
      },
      showlegend: false,
    },
  ],
  layout: {
    margin: { l: 50, r: 20, t: 10, b: 30 },
    xaxis: {
      title: "Log Odds Ratio (Treatment vs Control)",
      showgrid: true,
      gridcolor: "rgba(0,0,0,0.1)",
      range: [-5.2, 5.2], // Expanded to include all CI data (min: -4.94, max: 4.82)
      zeroline: true,
      zerolinecolor: "#9ca3af",
      zerolinewidth: 1.5,
    },
    yaxis: {
      title: "Site",
      showgrid: false,
      type: "category" as const,
      categoryorder: "array" as const,
      categoryarray: sites,
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    showlegend: false,
  },
};

// Fixed violin plot data
const rngViolin = seededRandom(11111);
const controlViolinData = Array.from({ length: 41 }, () => {
  const gaussian = () => {
    const u1 = rngViolin();
    const u2 = rngViolin();
    return Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  };
  return 55 + gaussian() * 8;
});

const rngTreatment = seededRandom(22222);
const treatmentViolinData = Array.from({ length: 35 }, () => {
  const gaussian = () => {
    const u1 = rngTreatment();
    const u2 = rngTreatment();
    return Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  };
  return 45 + gaussian() * 6;
});

export const violinPlotData = {
  data: [
    {
      box: { visible: true },
      fillcolor: "rgba(92,163,208,0.4)",
      line: { color: "#5CA3D0", width: 1 },
      name: "Control",
      opacity: 1,
      points: false,
      showlegend: true,
      x: Array(41).fill(0),
      y: controlViolinData,
      type: "violin" as const,
      marker: { color: "#5CA3D0" },
    },
    {
      box: { visible: true },
      fillcolor: "rgba(20,84,159,0.25)",
      line: { color: "#14549F", width: 1 },
      name: "Treatment",
      opacity: 1,
      points: false,
      showlegend: true,
      x: Array(35).fill(1),
      y: treatmentViolinData,
      type: "violin" as const,
      marker: { color: "#14549F" },
    },
  ],
  layout: {
    margin: { l: 50, r: 20, t: 10, b: 40 },
    xaxis: {
      title: "",
      showgrid: false,
      tickmode: "array" as const,
      tickvals: [0, 1],
      ticktext: ["Control (n=41)", "Treatment (n=35)"],
    },
    yaxis: {
      title: "Biomarker",
      showgrid: true,
      gridcolor: "rgba(0,0,0,0.1)",
      range: [40, 80],
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    showlegend: false,
  },
};

// Ridge plot data - extracted from actual ridgeline.js file
// Real density curves for Weeks 8, 10, and 12 (sampled every 20th point)
// Y-values are numeric density coordinates, not string labels

const WEEK8_CONTROL_X = [36.904, 38.622, 40.339, 42.056, 43.773, 45.491, 47.208, 48.925, 50.642, 52.359, 54.077, 55.794, 57.511, 59.228, 60.945, 62.663, 64.38, 66.097, 67.814, 69.532, 71.249, 72.966, 74.683, 76.4, 78.118, 79.749, 78.032, 76.315, 74.597, 72.88, 71.163, 69.446, 67.728, 66.011, 64.294, 62.577, 60.86, 59.142, 57.425, 55.708, 53.991, 52.274, 50.556, 48.839, 47.122, 45.405, 43.687, 41.97, 40.253, 38.536];
const WEEK8_CONTROL_Y = [11.026, 11.052, 11.093, 11.153, 11.232, 11.32, 11.4, 11.452, 11.474, 11.485, 11.515, 11.585, 11.689, 11.8, 11.88, 11.898, 11.843, 11.726, 11.579, 11.436, 11.323, 11.245, 11.194, 11.153, 11.115, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0];
const WEEK8_TREATMENT_X = [36.904, 38.622, 40.339, 42.056, 43.773, 45.491, 47.208, 48.925, 50.642, 52.359, 54.077, 55.794, 57.511, 59.228, 60.945, 62.663, 64.38, 66.097, 67.814, 69.532, 71.249, 72.966, 74.683, 76.4, 78.118, 79.749, 78.032, 76.315, 74.597, 72.88, 71.163, 69.446, 67.728, 66.011, 64.294, 62.577, 60.86, 59.142, 57.425, 55.708, 53.991, 52.274, 50.556, 48.839, 47.122, 45.405, 43.687, 41.97, 40.253, 38.536];
const WEEK8_TREATMENT_Y = [11.0, 11.001, 11.003, 11.01, 11.031, 11.078, 11.168, 11.31, 11.491, 11.677, 11.822, 11.894, 11.888, 11.828, 11.741, 11.647, 11.552, 11.455, 11.36, 11.274, 11.213, 11.183, 11.18, 11.183, 11.172, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0, 11.0];

const WEEK9_CONTROL_X = [36.904, 38.622, 40.339, 42.056, 43.773, 45.491, 47.208, 48.925, 50.642, 52.359, 54.077, 55.794, 57.511, 59.228, 60.945, 62.663, 64.38, 66.097, 67.814, 69.532, 71.249, 72.966, 74.683, 76.4, 78.118, 79.749, 78.032, 76.315, 74.597, 72.88, 71.163, 69.446, 67.728, 66.011, 64.294, 62.577, 60.86, 59.142, 57.425, 55.708, 53.991, 52.274, 50.556, 48.839, 47.122, 45.405, 43.687, 41.97, 40.253, 38.536];
const WEEK9_CONTROL_Y = [8.031, 8.052, 8.079, 8.113, 8.155, 8.205, 8.26, 8.324, 8.411, 8.531, 8.678, 8.814, 8.893, 8.883, 8.792, 8.661, 8.537, 8.445, 8.383, 8.334, 8.28, 8.217, 8.156, 8.107, 8.075, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0];
const WEEK9_TREATMENT_X = [36.904, 38.622, 40.339, 42.056, 43.773, 45.491, 47.208, 48.925, 50.642, 52.359, 54.077, 55.794, 57.511, 59.228, 60.945, 62.663, 64.38, 66.097, 67.814, 69.532, 71.249, 72.966, 74.683, 76.4, 78.118, 79.749, 78.032, 76.315, 74.597, 72.88, 71.163, 69.446, 67.728, 66.011, 64.294, 62.577, 60.86, 59.142, 57.425, 55.708, 53.991, 52.274, 50.556, 48.839, 47.122, 45.405, 43.687, 41.97, 40.253, 38.536];
const WEEK9_TREATMENT_Y = [8.01, 8.024, 8.05, 8.091, 8.154, 8.243, 8.361, 8.502, 8.651, 8.784, 8.873, 8.9, 8.865, 8.784, 8.679, 8.561, 8.441, 8.335, 8.259, 8.22, 8.209, 8.204, 8.188, 8.154, 8.109, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0, 8.0];



const WEEK11_CONTROL_X = [36.904, 38.622, 40.339, 42.056, 43.773, 45.491, 47.208, 48.925, 50.642, 52.359, 54.077, 55.794, 57.511, 59.228, 60.945, 62.663, 64.38, 66.097, 67.814, 69.532, 71.249, 72.966, 74.683, 76.4, 78.118, 79.749, 78.032, 76.315, 74.597, 72.88, 71.163, 69.446, 67.728, 66.011, 64.294, 62.577, 60.86, 59.142, 57.425, 55.708, 53.991, 52.274, 50.556, 48.839, 47.122, 45.405, 43.687, 41.97, 40.253, 38.536];
const WEEK11_CONTROL_Y = [9.01, 9.025, 9.055, 9.1, 9.16, 9.233, 9.319, 9.419, 9.529, 9.644, 9.754, 9.842, 9.893, 9.894, 9.846, 9.765, 9.679, 9.604, 9.541, 9.47, 9.376, 9.264, 9.155, 9.075, 9.029, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0];
const WEEK11_TREATMENT_X = [36.904, 38.622, 40.339, 42.056, 43.773, 45.491, 47.208, 48.925, 50.642, 52.359, 54.077, 55.794, 57.511, 59.228, 60.945, 62.663, 64.38, 66.097, 67.814, 69.532, 71.249, 72.966, 74.683, 76.4, 78.118, 79.749, 78.032, 76.315, 74.597, 72.88, 71.163, 69.446, 67.728, 66.011, 64.294, 62.577, 60.86, 59.142, 57.425, 55.708, 53.991, 52.274, 50.556, 48.839, 47.122, 45.405, 43.687, 41.97, 40.253, 38.536];
const WEEK11_TREATMENT_Y = [9.001, 9.006, 9.02, 9.054, 9.121, 9.232, 9.383, 9.552, 9.704, 9.815, 9.88, 9.9, 9.872, 9.801, 9.706, 9.608, 9.519, 9.437, 9.358, 9.286, 9.226, 9.178, 9.132, 9.086, 9.047, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0, 9.0];

// Helper function to create y-coordinates for ridge plot
// Positions the density curve at the target week number with appropriate height
// Since y-axis is reversed, we subtract the offset so ridges extend upward
const createRidgeY = (densityY: number[], targetWeek: number): number[] => {
  // Find the minimum density value (baseline)
  const minDensity = Math.min(...densityY);
  // Scale factor to control ridge height (adjust this to make ridges taller/shorter)
  const scaleFactor = 0.8;
  
  // Normalize density values to create offset from base week number
  // The baseline (minDensity) maps to the target week number
  // We subtract the offset because the y-axis is reversed (higher values at bottom)
  return densityY.map(density => {
    const offset = (density - minDensity) * scaleFactor;
    return targetWeek - offset; // Subtract for reversed axis
  });
};

// Helper functions to shift curves to create divergence
// Week 8: minimal divergence (shift by 0.5)
// Week 10: medium divergence (shift by 1.5)
// Week 12: maximum divergence (shift by 2.5)
const shiftControlRight = (x: number[], week: number): number[] => {
  const shift = (week - 8) * 0.5 + 0.5; // 0.5 for week 8, 1.5 for week 10, 2.5 for week 12
  return x.map(val => val + shift);
};

const shiftTreatmentLeft = (x: number[], week: number): number[] => {
  const shift = (week - 8) * 0.5 + 0.5; // 0.5 for week 8, 1.5 for week 10, 2.5 for week 12
  return x.map(val => val - shift);
};

export const ridgePlotData = {
  data: [
    // Week 8 - Control (uses WEEK9 data, minimal divergence)
    {
      fill: "toself" as const,
      hoverinfo: "skip" as const,
      line: { color: "#5CA3D0", width: 1.5 },
      mode: "lines" as const,
      name: "Control",
      showlegend: false,
      x: shiftControlRight(WEEK9_CONTROL_X, 8),
      y: createRidgeY(WEEK9_CONTROL_Y, 8),
      type: "scatter" as const,
      fillcolor: "rgba(92,163,208,0.3)",
    },
    // Week 8 - Treatment (uses WEEK9 data, minimal divergence)
    {
      fill: "toself" as const,
      hoverinfo: "skip" as const,
      line: { color: "#14549F", width: 1.5 },
      mode: "lines" as const,
      name: "Treatment",
      showlegend: false,
      x: shiftTreatmentLeft(WEEK9_TREATMENT_X, 8),
      y: createRidgeY(WEEK9_TREATMENT_Y, 8),
      type: "scatter" as const,
      fillcolor: "rgba(20,84,159,0.3)",
    },
    // Week 10 - Control (uses WEEK11 data, medium divergence)
    {
      fill: "toself" as const,
      hoverinfo: "skip" as const,
      line: { color: "#5CA3D0", width: 1.5 },
      mode: "lines" as const,
      name: "Control",
      showlegend: false,
      x: shiftControlRight(WEEK11_CONTROL_X, 10),
      y: createRidgeY(WEEK11_CONTROL_Y, 10),
      type: "scatter" as const,
      fillcolor: "rgba(92,163,208,0.3)",
    },
    // Week 10 - Treatment (uses WEEK11 data, medium divergence)
    {
      fill: "toself" as const,
      hoverinfo: "skip" as const,
      line: { color: "#14549F", width: 1.5 },
      mode: "lines" as const,
      name: "Treatment",
      showlegend: false,
      x: shiftTreatmentLeft(WEEK11_TREATMENT_X, 10),
      y: createRidgeY(WEEK11_TREATMENT_Y, 10),
      type: "scatter" as const,
      fillcolor: "rgba(20,84,159,0.3)",
    },
    // Week 12 - Control (uses WEEK8 data, maximum divergence)
    {
      fill: "toself" as const,
      hoverinfo: "skip" as const,
      line: { color: "#5CA3D0", width: 1.5 },
      mode: "lines" as const,
      name: "Control",
      showlegend: false,
      x: shiftControlRight(WEEK8_CONTROL_X, 12),
      y: createRidgeY(WEEK8_CONTROL_Y, 12),
      type: "scatter" as const,
      fillcolor: "rgba(92,163,208,0.3)",
    },
    // Week 12 - Treatment (uses WEEK8 data, maximum divergence)
    {
      fill: "toself" as const,
      hoverinfo: "skip" as const,
      line: { color: "#14549F", width: 1.5 },
      mode: "lines" as const,
      name: "Treatment",
      showlegend: false,
      x: shiftTreatmentLeft(WEEK8_TREATMENT_X, 12),
      y: createRidgeY(WEEK8_TREATMENT_Y, 12),
      type: "scatter" as const,
      fillcolor: "rgba(20,84,159,0.3)",
    },
  ],
  layout: {
    margin: { l: 50, r: 20, t: 10, b: 40 },
    xaxis: {
      title: "Biomarker Value",
      showgrid: true,
      gridcolor: "rgba(0,0,0,0.1)",
      range: [40, 70],
    },
    yaxis: {
      title: "Week (0 at top)",
      showgrid: false,
      tickmode: "array" as const,
      tickvals: [8, 10, 12],
      ticktext: ["8", "10", "12"],
      autorange: "reversed" as const,
      range: [13, 7], // Extended range to accommodate ridge heights above week numbers
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    showlegend: false,
  },
};

